// extracted by mini-css-extract-plugin
export var notificationHost = "_mq-0";